import * as Yup from "yup"

export default function validation_location_ids(field, acc) {
  const { field_name, field_validation } = field

  const checkBool = () => {
    if (!field_validation.required) return false
    return field_validation.required[0] === "true" ? true : false
  }

  const isRequired = checkBool()
  const isRequiredTxt =
    (field_validation.required && field_validation.required[1]) ||
    "Required field."

  if (!isRequired) return acc

  return {
    [field_name]:  Yup.array().of(
      Yup.object().shape({
        key: Yup.string(),
      })
      ).required(isRequiredTxt).min(1, "You must select a location."),
    ...acc,
  }
}